"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isModalOpen = void 0;
function isModalOpen(modal) {
    if (modal) {
        console.warn('modal parameter is deprecated');
    }
    return this.modal.classList.contains('open') ||
        this.modal.hasAttribute('open');
}
exports.isModalOpen = isModalOpen;
//# sourceMappingURL=helpers.js.map